import APIError from '../APIError';
class Forbidden extends APIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 403;
        super(status, ...args);
    }
}
export default Forbidden;
